import { TableFooter, TablePagination, TableRow } from '@material-ui/core';
import React from 'react';

const TableFooterPagination = ({
  styles,
  state,
  page,
  rowsPerPage,
  setStateAction,
}) => {
  return (
    <TableFooter
      className="sticky"
      style={{ bottom: '0px', background: '#bababa' }}
    >
      <TableRow className="sticky" style={{ bottom: '0px' }}>
        <div style={styles.bottomdiv}>
          {state.refreshUOA && state.time < '16:00'
            ? `Next refresh will be at ${state.nextRefreshTime}`
            : ''}
        </div>
        {!!state.localUOA ? (
          <TablePagination
            className="sticky"
            style={{ ...styles.pagenation, bottom: '0px' }}
            rowsPerPageOptions={[]}
            count={state.localUOA.length}
            rowsPerPage={rowsPerPage}
            page={page - 1}
            onChangePage={(evt, newPage) => {
              setStateAction({
                page: newPage + 1,
              });
            }}
          ></TablePagination>
        ) : (
          ''
        )}
      </TableRow>
    </TableFooter>
  );
};

export default TableFooterPagination;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/tableFooterPaginaion.jsx